/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const PfLink = zod.object({
  url: zod.string(),
})

export type PfLink = zod.input<typeof PfLink>
export type PfLinkOutput = zod.output<typeof PfLink>
